module.exports = __webpack_public_path__ + "img/download.4cd028c4.svg";